export enum unit {
    SI = 'Metric',
    Imperial = 'Imperial',
}

export enum EProjectType {
    paved = 'paved',
    unpaved = 'unpaved',
    working_platforms = 'working_platforms',
    railways = 'railways',
    container_yard = 'container_yard',
    parking_deck = 'parking_deck',
    airport = 'airport',
    project = 'project',
    geogrid = 'geogrid',
    
}
